import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function RijekaIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="RijekaIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="currentcolor" d="M68.015,57.526c-4.768,0-8.633,3.865-8.633,8.633c0,3.952,2.659,7.276,6.283,8.301v6.555h4.7V74.46 c3.624-1.024,6.283-4.349,6.283-8.301C76.648,61.392,72.783,57.526,68.015,57.526z"/>
      <path fill="currentcolor" d="M51.851,55.266c-8.682,9.042-17.659,18.392-33.07,18.392v4.801c17.457,0,27.591-10.556,36.533-19.868 c8.029-8.363,14.963-15.585,25.906-15.585v-4.801C68.231,38.204,59.904,46.878,51.851,55.266z"/>
      <path fill="currentcolor" d="M48.251,45.913c-8.229,7.442-16.002,14.473-29.47,14.473v4.801c15.317,0,24.149-7.988,32.69-15.714 c8.282-7.49,16.104-14.565,29.749-14.565v-4.801C65.726,30.107,56.842,38.142,48.251,45.913z"/>
      <polygon fill="currentcolor" points="30.715,47.922 35.415,47.922 35.415,41.693 43.363,41.693 33.065,23.938 22.767,41.693 30.715,41.693"/>
    </svg>
  </SvgIcon>
}

export default RijekaIcon;
